import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function FeaturedAnime() {
  const featured = animeList.slice(0, 8);

  return (
    <section className="py-12 md:py-16">
      <div className="container-custom">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="section-title">热门推荐</h2>
            <p className="section-subtitle">大家都在追的高分番剧</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-primary-400 text-sm hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((anime) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="anime-card group"
            >
              <div className="aspect-[2/3] overflow-hidden rounded-lg bg-background-800">
                <img
                  src={anime.coverImage}
                  alt={anime.title}
                  title={`${anime.title} - 6080影视免费高清在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500/90 text-background-950 text-xs font-bold">
                  {anime.rating}
                </div>
                <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-primary-400 text-xs">
                  {anime.status}
                </div>
              </div>
              <div className="mt-2.5">
                <h4 className="text-foreground-100 text-sm font-medium line-clamp-1 group-hover:text-primary-400 transition-colors">
                  {anime.title}
                </h4>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-foreground-500 text-xs">{anime.region}</span>
                  <span className="text-foreground-700 text-xs">·</span>
                  <span className="text-foreground-500 text-xs">{anime.year}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="btn-primary text-sm px-6 py-2.5 rounded-full inline-flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}